<template>
    <div class="spinner_container" :style="positionStyle">
        <scale_loader
            :color="color"
            :height="height"
            :width="width"
        />
    </div>
</template>

<script>
import scale_loader from "vue-spinner/src/ScaleLoader.vue";
export default {
    name: "spinner",
    props:{
        color: {
            type: String,
            default: '#F6673C'
        },
        height: {
            type: String,
            default: '35px'
        },
        width: {
            type: String,
            default: '4px'
        },
        position: {
            type: String,
            required: false,
            default: 'center',
        }
    },
    components:{scale_loader},
    computed:{
        positionStyle(){
            return 'justify-content: ' + this.position + ';';
        }
    }
}
</script>
